import { styled } from '@mui/material/styles';
import { Button, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  ConciliationDetailDataGrid,
  ConciliationDetailSearch,
  ConciliationDetailInfoCards,
} from '../components';
import FiltersLayoutHandler from '../components/FiltersLayoutHandler';
import { reportConciliationDetailLoadingSelector } from '../state';
import { conciliationHeaderKeys } from '../types';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  '.MuiToolbar-root': {
    marginTop: theme.spacing(3),
  },
}));

const ConciliationDetail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const cameFromHeader = Boolean(searchParams.get(conciliationHeaderKeys.conciliationHeaderId));

  return (
    <Container>
      {cameFromHeader && (
        <Box sx={{ pt: 2, pl: 1 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(-1)} variant="text">
            {t('navigation.buttons.back')}
          </Button>
        </Box>
      )}
      <FiltersLayoutHandler selector={reportConciliationDetailLoadingSelector}>
        <ConciliationDetailSearch />
      </FiltersLayoutHandler>
      <ConciliationDetailInfoCards />
      <ConciliationDetailDataGrid />
    </Container>
  );
};

export default ConciliationDetail;
